import React, { useState, useEffect } from 'react';
import {
  Container,
  Box,
  Typography,
  Paper,
  Divider,
  CircularProgress,
  IconButton,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import RankingTable from '../../components/RankingTable';
import PageTitle from '../../components/PageTitle';

const GeneralRankingPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [players, setPlayers] = useState([]);

  useEffect(() => {
    // TODO: Replace with actual API call
    const fetchRankings = async () => {
      try {
        // Simulated data for now
        const mockPlayers = [
          { id: 1, name: 'Juan Pérez', torCode: 'TOR001', matches: 30, wins: 25, points: 75, store: 'Warpig Games' },
          { id: 2, name: 'María García', torCode: 'TOR002', matches: 28, wins: 22, points: 66, store: 'El Hobbit' },
          { id: 3, name: 'Carlos López', torCode: 'TOR003', matches: 25, wins: 20, points: 60, store: 'Infinity Games' },
          { id: 4, name: 'Ana Martínez', torCode: 'TOR004', matches: 22, wins: 17, points: 51, store: 'Warpig Games' },
          { id: 5, name: 'Diego Soto', torCode: 'TOR005', matches: 20, wins: 15, points: 45, store: 'El Hobbit' },
          { id: 6, name: 'Laura Torres', torCode: 'TOR006', matches: 18, wins: 13, points: 39, store: 'Gamer Studio' },
          { id: 7, name: 'Pedro Rojas', torCode: 'TOR007', matches: 17, wins: 12, points: 36, store: 'Infinity Games' },
          { id: 8, name: 'Carmen Silva', torCode: 'TOR008', matches: 16, wins: 11, points: 33, store: 'Warpig Games' },
          { id: 9, name: 'Jorge Muñoz', torCode: 'TOR009', matches: 15, wins: 10, points: 30, store: 'El Hobbit' },
          { id: 10, name: 'Isabel Castro', torCode: 'TOR010', matches: 14, wins: 9, points: 27, store: 'Gamer Studio' },
          { id: 11, name: 'Roberto Díaz', torCode: 'TOR011', matches: 13, wins: 8, points: 24, store: 'Infinity Games' },
          { id: 12, name: 'Patricia Vera', torCode: 'TOR012', matches: 12, wins: 7, points: 21, store: 'Warpig Games' },
          { id: 13, name: 'Miguel Parra', torCode: 'TOR013', matches: 11, wins: 6, points: 18, store: 'El Hobbit' },
          { id: 14, name: 'Daniela Ríos', torCode: 'TOR014', matches: 10, wins: 5, points: 15, store: 'Gamer Studio' },
          { id: 15, name: 'Fernando Bravo', torCode: 'TOR015', matches: 9, wins: 4, points: 12, store: 'Infinity Games' },
        ];
        setPlayers(mockPlayers);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching rankings:', error);
        setLoading(false);
      }
    };

    fetchRankings();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress sx={{ color: '#c89e38' }} />
      </Box>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
        <IconButton 
          onClick={() => navigate('/torneos')}
          sx={{ 
            width: 40,
            height: 40,
            bgcolor: 'action.hover',
            color: 'text.primary',
            '&:hover': { 
              bgcolor: '#c89e38',
              color: 'white',
              transform: 'scale(1.1)'
            },
            transition: 'all 0.2s ease-in-out'
          }}
        >
          <ArrowBackIcon />
        </IconButton>
        <PageTitle title="Ranking General" />
      </Box>
      
      <Paper 
        elevation={0}
        sx={{ 
          p: 3, 
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2
        }}
      >
        <Typography variant="h6" gutterBottom>
          Temporada Actual
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          Ranking actualizado con los resultados de todos los torneos de la temporada
        </Typography>
        <Divider sx={{ my: 2 }} />
        
        <RankingTable players={players} showStore={false} />
      </Paper>
    </Container>
  );
};

export default GeneralRankingPage; 